import { useState } from 'react';
import { type RequestToken } from '../../types';
import { type HandlerAppInfo } from '../../data/handlerApps';
import { useTranslation } from '../../i18n/i18n';
import MobileLayout from '../../layouts/MobileLayout';
import FlowFooter from '../../components/FlowFooter';
import FaqModal, { type FaqTopic } from '../../components/FaqModal';
import NeedHelpSection from '../../components/NeedHelpSection';
import AppPickerContent from '../shared/AppPickerContent';

type Props = {
  tokens: RequestToken[];
  handlerApps: Record<string, HandlerAppInfo>;
  recommendedHandlerAppUuids: string[];
  onSelect: (token: RequestToken) => void;
  onCancel: () => void;
};

export default function MobileAppPickerPage({
  tokens,
  handlerApps,
  recommendedHandlerAppUuids,
  onSelect,
  onCancel,
}: Props) {
  const { t } = useTranslation();
  const [faqTopic, setFaqTopic] = useState<FaqTopic | null>(null);

  return (
    <MobileLayout
      footer={
        <FlowFooter
          secondaryLabel={t('agentStart.cancel')}
          onSecondary={onCancel}
        />
      }
    >
      <div>
        <h2
          data-testid="app-picker-title"
          className="text-xl font-semibold text-foreground text-center"
        >
          {t('appPicker.title')}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground text-center">
          {t('appPicker.subtitle')}
        </p>
      </div>

      <AppPickerContent
        className="max-h-[calc(50vh+5rem)]"
        tokens={tokens}
        handlerApps={handlerApps}
        recommendedHandlerAppUuids={recommendedHandlerAppUuids}
        onSelect={onSelect}
      />

      <NeedHelpSection
        topics={['whatAreWallets', 'whyNotSupported']}
        onSelectTopic={setFaqTopic}
      />
      <FaqModal
        topic={faqTopic}
        onChangeTopic={setFaqTopic}
        onClose={() => setFaqTopic(null)}
      />
    </MobileLayout>
  );
}
